<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<onboarding-container [displayProgressBar]="false" [hideForward]="true" [hideBack]="true">
  <img src="/assets/img/onboarding/investment-strategy/success.svg" alt="investment-strategy-success" />
  <div class="zero-text p-huge-med text-center mt-4">{{ 'investment-strategy.success.headline' | transloco }}</div>
  <div class="zero-text p-base-med text-center mt-2">{{ 'investment-strategy.success.text' | transloco }}</div>
  <div class="mt-3 d-flex justify-content-center">
    <web-design-system-button [routerLink]="home">{{ 'investment-strategy.success.btn' | transloco }}</web-design-system-button>
  </div>
</onboarding-container>
